import { AboutUsTrustpilot } from "./AboutUsTrustpilot";
import type { AboutUsTrustpilotProps } from "./AboutUsTrustpilot.d";

export { AboutUsTrustpilot, AboutUsTrustpilotProps };
